<div class="btn" [ngStyle]="{'height': height}">
  {{ text }}
</div>